import AbstractComponent from "./abstract-component";

const createDivTemplate = (className) => {
  return (
    `<div class="${className}"></div>`
  );
};

export default class DivComponent extends AbstractComponent {
  constructor(className = ``) {
    super();

    this._className = className;
  }

  getTemplate() {
    return createDivTemplate(this._className);
  }

  setClickHandler(handler) {
    this.getElement().addEventListener(`click`, handler);
  }
}
